import { render } from "./DelegationReasons.vue?vue&type=template&id=b3108eaa"
import script from "./DelegationReasons.vue?vue&type=script&lang=js"
export * from "./DelegationReasons.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__